// ./client/src/components/Admin/adminMessages.js
import React, { useState } from "react";
import { MessageLog, NotifyEta, SendSms } from "../Messages";

const VoipServices = () => {

  return (
    <>
      <div className="group whole">
        {/* --- NotifyEta component test --- */}
        <form className="form" id="test-panel">
          <h3>Texting Test Panel</h3>
          <div className="form-center">
            <h5>Send Test ETA Text Message</h5>
            <div className="whole">
              <NotifyEta testMode />
            </div>
          </div>
          {/* --- Send general text component test --- */}
          <br/>
          <h5>Send Test General Text Message</h5>
          <SendSms testMode />
        </form>
      </div>
      <div className="group whole">
        {/* --- Show all recent messages --- */}
        <MessageLog />
      </div>
    </>
  );
};

export default VoipServices;
